import scssVariables from './variables.module.scss';

export const breackpoints = {
    breackpointPhone: scssVariables['breackpoint-phone'],
    breackpointTablets: scssVariables['breackpoint-tablets'],
    breackpointLaptops: scssVariables['breackpoint-laptops'],
    breackpointDesktop: scssVariables['breackpoint-desktop']
};
